import React from "react"
import { withMyDataContext } from "../context/DataProvider";
import InstagramIcon from "mdi-react/InstagramIcon"
import SnapchatIcon from "mdi-react/SnapchatIcon"
import TwitterIcon from "mdi-react/TwitterIcon"
import YoutubeIcon from "mdi-react/YoutubeIcon"
import FacebookIcon from "mdi-react/FacebookIcon"
import Colors from "../utils/Colors";
import Aux from "../utils/AuxFunctions";
import ChevronRightIcon from "mdi-react/ChevronRightIcon";
import PencilIcon from "mdi-react/PencilIcon";
import { Link } from "react-router-dom";
import Loader from "../utils/Utilities/Loader";

class ProfileHeader extends React.Component {

    render() {
        let isMyProfile = false
        if (this.props.myDataProvider.user)
            isMyProfile = this.props.user?.username === this.props.myDataProvider.user.username
        return (
            <div>
                {this.props.user ?
                    <div style={{ margin: 10, marginTop: 30, marginBottom: 0 }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ display: "flex" }}>
                                <div>
                                    {Aux.showAvatar(75, this.props.user.avatar, this.props.user.username || "Unknown")}
                                </div>
                                <div style={{ marginBottom: 6, display: "flex", flexDirection: "column", marginLeft: 20, justifyContent: "center", alignItems: "start" }} >
                                    {this.props.user.name ? <span style={{ fontSize: 18, fontWeight: "bold", margin: "3px 0px", }}>
                                        {this.props.user.name}
                                    </span> : null}
                                    {this.props.user.username ?
                                        <span style={{ fontSize: 16, fontWeight: "600", color: Colors.middleText, overflowWrap: "anywhere" }}>
                                            @{this.props.user.username}
                                        </span> : null}
                                    {this.props.user.bio ?
                                        <span style={{ margin: "3px 0px", wordBreak: "break-all" }}>
                                            {this.props.user.bio}
                                        </span> : null}
                                    {this.props.user.website ?
                                        <a style={{ color: Colors.link, }} href={"http://" + this.props.user.website} target="_blank" rel="noopener noreferrer">
                                            {this.props.user.website}
                                        </a> : null}
                                </div>
                            </div>
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-around", margin: "15px 0", flexWrap: "wrap" }}>
                            {this.props.user.instagram ? (
                                <a style={{ display: "flex", justifyContent: "center", alignItems: "center", textDecoration: "none" }} className="text-hover" href={"https://www.instagram.com/" + this.props.user.instagram} target="_blank" rel="noopener noreferrer">
                                    <InstagramIcon style={{ color: Colors.instagram, alignSelf: "center" }} name="instagram" size={25} />
                                    <span style={{ marginLeft: 5, color: "#555" }}  >{this.props.user.instagram}</span>
                                </a>) : null}
                            {this.props.user.twitter ? (
                                <a style={{ display: "flex", justifyContent: "center", alignItems: "center", textDecoration: "none" }} className="text-hover"
                                    href={"https://twitter.com/" + this.props.user.twitter} target="_blank" rel="noopener noreferrer">
                                    <TwitterIcon style={{ color: Colors.twitter, alignSelf: "center" }} name="twitter" size={25} />
                                    <span style={{ marginLeft: 5, color: "#555" }} >{this.props.user.twitter}</span>
                                </a>) : null}
                            {this.props.user.youtube ? (
                                <a style={{ display: "flex", justifyContent: "center", alignItems: "center", textDecoration: "none" }} className="text-hover"
                                    href={"https://youtube.com/" + this.props.user.youtube} target="_blank" rel="noopener noreferrer">
                                    <YoutubeIcon style={{ color: Colors.youtube, alignSelf: "center" }} name="youtube" size={25} />
                                    <span style={{ marginLeft: 5, color: "#555" }} >{this.props.user.youtube}</span>
                                </a>) : null}
                            {this.props.user.facebook ? (
                                <a style={{ display: "flex", justifyContent: "center", alignItems: "center", textDecoration: "none" }} className="text-hover"
                                    href={"https://facebook.com/" + this.props.user.facebook} target="_blank" rel="noopener noreferrer">
                                    <FacebookIcon style={{ color: Colors.facebook, alignSelf: "center" }} name="facebook" size={25} />
                                    <span style={{ marginLeft: 5, color: "#555" }} >{this.props.user.facebook}</span>
                                </a>) : null}
                            {this.props.user.snapchat ? (
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textDecoration: "none" }} >
                                    <SnapchatIcon style={{ color: Colors.snapchat, alignSelf: "center" }} name="snapchat" size={25} />
                                    <span style={{ marginLeft: 5, color: "#555" }} >{this.props.user.snapchat}</span>
                                </div>) : null}
                        </div>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around", marginBottom: 20 }}>
                            {isMyProfile ?
                                <Link to={"/account/edit"} style={{ textDecoration: "none", color: Colors.darkText }}>
                                    <div className="send-gift-profile" onClick={this.props.sendMessage} style={{ padding: "10px 20px", borderRadius: 10, border: "2px solid", borderColor: Colors.mainColor, display: "flex", alignItems: "center" }}>
                                        <span style={{ fontSize: 15, fontWeight: "300", marginRight: 5 }}>Edit Profile</span>
                                        <PencilIcon size={20} />
                                    </div>
                                </Link> :
                                <div className="send-gift-profile" onClick={this.props.sendMessage} style={{ padding: "10px 20px", borderRadius: 10, border: "2px solid", borderColor: Colors.mainColor, display: "flex", alignItems: "center" }}>
                                    <span style={{ fontSize: 15, fontWeight: "300" }}>Send Message</span>
                                    <ChevronRightIcon />
                                </div>
                            }
                            <div style={{ /* backgroundColor: "#e5e5e5", */ padding: "10px 20px", borderRadius: 10, display: "flex", }}>
                                <span style={{ alignSelf: "center", fontSize: 15, fontWeight: "300" }}>Posts</span>
                                <span style={{ alignSelf: "center", color: Colors.darkText, fontSize: 18, fontWeight: "bold", marginLeft: 20 }}>
                                    {this.props.user.postsCount || 0}
                                </span>
                            </div>

                            <div style={{ /* backgroundColor: "#e5e5e5", */ padding: "10px 20px", borderRadius: 10, display: "flex", }}>
                                <span style={{ alignSelf: "center", fontSize: 15, fontWeight: "300" }}>Total Spent</span>
                                <span style={{ alignSelf: "center", color: Colors.darkText, fontSize: 18, fontWeight: "bold", marginLeft: 20 }}>
                                    ${this.props.user.coinsSpent || 0}
                                </span>
                            </div>
                        </div>
                        
                    </div>
                    : <Loader style={{ marginTop: 20 }}></Loader>}
                <div style={{ borderBottom: "2px solid #ddd" }} />
            </div>
        )
    }
}

export default withMyDataContext(ProfileHeader)